import { Injectable } from '@angular/core';
import {BoardsApiService} from './api/boards-api.service';
import { ExternalEntity } from './api/types/external-entities.types';
import {Observable, of, tap} from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class SaveWelcomeBoardService {
  constructor(private boardsApi: BoardsApiService) {}

  getWelcomeBoardElementsState() {
    const state = localStorage.getItem('guest-map-state');

    if (!state) {
      return null;
    }

    try {
      const parsedState: Record<string, any>[] = JSON.parse(state);

      if (!parsedState.length) {
        return null;
      }

      return parsedState;
    } catch (e) {
      localStorage.removeItem('guest-map-state');
      console.error(e);
      return null;
    }
  }
  isWelcomeBoardElementsSaved(): boolean {
    const state = this.getWelcomeBoardElementsState();

    if (!state) {
      return false;
    }

    return !!state.length;
  }
  createWelcomeBoardElementsFromLS(): Observable<{  boardId: string } | null> {
    const state = this.getWelcomeBoardElementsState();

    if (!state) {
      return of(null);
    }

    return this.boardsApi.createBoardFromDefault(state as ExternalEntity[]).pipe(tap(() => {
      localStorage.removeItem('guest-map-state');
    }))
  }
}
